// extracted by mini-css-extract-plugin
module.exports = {"mobileWidth":"550px","wrapper":"page-container_wrapper__e0WQW","container":"page-container_container__BjbhI","noBorder":"page-container_noBorder__ag0Lg"};